exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".fz-15[data-v-3a5ccd40]{font-size:15px}.icon_close[data-v-3a5ccd40]{position:absolute;right:4px;line-height:25px}", ""]);

// exports
